<script setup>
import AddNewBot from '@/views/apps/bot/list/AddNewBot.vue'
import { useRoute } from 'vue-router'
import BotsController from '@/Controller/bots'
import { onMounted } from 'vue'
import { useToast } from 'vue-toastification'
import { getCurrentInstance } from 'vue'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})



// Get the bot ID from the route params
const route = useRoute()
const botId = route.params.id

const bot = ref({})
const toast = useToast()
const proxy = getCurrentInstance().proxy

onMounted(
  async () => {
    bot.value =await BotsController.getBot(botId)
    console.log(bot)
  },
)

const upsertBot = async botData => {
  try{
    let newBotData = await BotsController.upsertBot(botData?.id, botData)
    toast.success(proxy.$t('Edit Bot Successfully'))
  }catch(e){
    console.log(e)
    toast.error(proxy.$t('Edit Bot Failed'))
  }
}
</script>

<template>
  <AddNewBot 
    :edit-mode="bot?.id" 
    :bot-to-edit="bot" 
    :show-cancel-button="false"
    :clear-after-submit="false"
    @bot-data="upsertBot($event)"/>
</template>
